import React from 'react';

import {FilterInput} from 'src/components/input';

import Label from '@pb/kit-component-label';


type Props = {
    message?: string,
    onChange: (accountName: string) => void,
};

export const AlertMessageFilter = ({message, onChange}: Props) => (
    <div style={{width: 250}}>
        <Label>Alert message</Label>
        <FilterInput
            id="account-name"
            value={message || ''}
            placeholder="Alert message"
            onChange={onChange}
            onClear={() => onChange('')}
            timeOut={500}
        />
    </div>
);
